import {Scalars} from "../../../schema";
import {PlayerReduxState} from "../types";

export default function getChosenBranches(state: PlayerReduxState): Set<Scalars["ID"]> {
  return state.chosenBranches;
}